import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Permissions } from '@app/core/guard/Permissions';
import { VaultBaseComponent } from '@app/shared/components/base/vault-base.component';
import { TableAction, TableActions } from '@app/shared/components/table/table.component';
import { PermissionGroup } from '@interfaces/a-organizar/permissionGroup';
import { Pagination } from '@interfaces/common/pagination';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogService } from '@services/helpers/dialog.service';
import { PaginatorState } from 'primeng/paginator';

@Component({
  selector: 'app-group-list-content',
  templateUrl: './group-list-content.component.html',
  styleUrls: ['./group-list-content.component.scss'],
  standalone: false,
})
export class GroupListContentComponent extends VaultBaseComponent implements OnInit {
  /** Primeira listagem em andamento: mantém a tabela visível para o esqueleto aparecer. */
  @Input() loading = false;
  @Input() groupList: PermissionGroup[] = [];
  @Input() pagination: Pagination = {
    total: 0,
    currentPage: 0,
    pages: 0,
    itemsPerPage: 0,
  };
  @Output() sendTablePagination: EventEmitter<PaginatorState> = new EventEmitter<PaginatorState>();
  @Output() sendTableAction: EventEmitter<TableActions<PermissionGroup>> = new EventEmitter<
    TableActions<PermissionGroup>
  >();

  groupPermissions = Permissions.PermissionGroup;
  headers: string[] = [];
  columns: string[] = [];

  constructor(
    translateService: TranslateService,
    private router: Router,
    private dialogService: ConfirmDialogService
  ) {
    super(translateService);
  }

  ngOnInit(): void {
    this.headers = [
      this.t(this.tk.User.Name),
      this.t(this.tk.User.Profile),
      this.t(this.tk.General.Users),
      this.t(this.tk.User.Status),
      '',
      '',
    ];
    this.columns = ['name', 'role', 'users', 'status', 'edit', 'options'];
  }

  addGroup(): void {
    this.router.navigate(['dashboard/groups/register']);
  }

  handleTableAction(tableAction: TableAction<PermissionGroup>) {
    if (tableAction.action === 'edit') {
      this.router.navigate(['dashboard/groups/register', tableAction.item.id]);
    }
  }

  handleTableSelection({ action, items }: TableActions<PermissionGroup>) {
    switch (action) {
      case 'delete':
        this.dialogService
          .confirm(
            this.t(this.tk.User.UserGroupDescriptionDeleteConfirmation),
            this.t(this.tk.User.UserGroupTitleDeleteConfirmation),
            this.t(this.tk.General.Yes),
            this.t(this.tk.General.No)
          )
          .then(response => {
            if (response) {
              this.sendTableAction.emit({ action, items });
            }
          })
          .catch(error => {
            console.error('Error: ', error);
          });
        break;
    }
  }

  handleTablePagination(pagination: PaginatorState) {
    this.sendTablePagination.emit(pagination);
  }

  get formatedGroupList(): PermissionGroup[] {
    const formated = this.groupList.map((group: PermissionGroup) => {
      return group;
    });
    return formated;
  }
}
